import { Link } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';

export function PageLayout({ title, lastUpdated = 'April 2026', children }) {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 flex flex-col">
      <Navbar />
      <main className="flex-1 pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto w-full">
          <Link
            to="/"
            className="text-sm font-medium text-[#25D366] hover:text-[#1DA851] transition-colors mb-8 inline-block"
          >
            ← Back to home
          </Link>
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white mb-2">
            {title}
          </h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-10">
            Last updated: {lastUpdated}
          </p>
          <div className="space-y-6 text-slate-600 dark:text-slate-300 leading-relaxed">
            {children}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
